export default {
  tipAlternatives: [],
  tipAlternative: undefined,
};
